<template>
    <card :minify="minified">
        <card-header v-if="!minified">
            <card-title>
                <translate>editierbare Angebote</translate>
            </card-title>
        </card-header>
        <card-content>
            <table class="table table--stripped">
                <thead>
                <tr>
                    <th>
                        <translate>PF-Nr</translate>
                    </th>
                    <th class="text-center">
                        <translate>Zeichnung</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stück</translate>
                    </th>
                    <th class="text-right">
                        <translate>Stückpreis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Preis</translate>
                    </th>
                    <th class="text-right">
                        <translate>meine Lieferzeit</translate>
                    </th>
                    <th class="text-right">
                        <translate>Wunschlieferzeit</translate>
                    </th>
                    <th class="text-right">
                        <translate>editierbar bis</translate>
                    </th>
                    <th class="text-right">
                        <translate>Anzahl Angebote</translate>
                    </th>
                    <th class="text-center">
                        <translate>bearbeiten</translate>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="offer in editableOffersTable" :key="offer.index">
                    <td>
                        <Link :href="offer.url">{{ offer.ask_for_quote.pfnumber }}</Link>
                    </td>
                    <td class="text-center">
                        <file-download :sketch-file="offer.ask_for_quote?.producer_sketch_file" v-if="offer.ask_for_quote?.producer_sketch_file"/>
                        <file-download :cad-file="offer.ask_for_quote?.producer_cad_file" v-if="offer.ask_for_quote?.producer_cad_file"/>
                    </td>
                    <td class="text-right" v-html="offer.lot_qty"></td>
                    <td class="text-right" v-html="offer.price_per_unit"></td>
                    <td class="text-right" v-html="offer.lot_offer"></td>
                    <td class="text-right" v-html="offer.lot_delivery"></td>
                    <td class="text-right">{{ offer.delivery_days_for_producer }}</td>
                    <td class="text-right">{{ offer.bidround_ending_at }}</td>
                    <td class="text-right">{{ offer.bid_round_member_offers_count }}</td>
                    <td class="text-center">
                        <form-link-button :route="offer.url" dense="true" icon="document-edit" />
                    </td>
                </tr>
                <tr v-if="noOffers">
                    <td colspan="10" class="text-center">
                        <strong>
                            <translate>keine Einträge vorhanden</translate>
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import FileDownload from '@partfactory/Shared/Elements/FileDownload';

export default {
    name: 'DashboardEditableOffers',
    components: {FileDownload, FormLinkButton, CardContent, CardTitle, CardHeader, Card},
    props: {
        editableOffers: Object,
        minified: Boolean,
    },
    computed: {
        editableOffersTable() {
            let offer = Array;
            return Object.keys(this.editableOffers).map(key => {
                offer[key] = this.editableOffers[key];

                offer[key].url = this.$$route('quote.show', {'bidRoundMember' : offer[key].bid_round_member.id});

                let lotQty = [];
                lotQty.push(offer[key].lotqty_1, offer[key].lotqty_2, offer[key].lotqty_3, offer[key].lotqty_4);
                offer[key].lot_qty = lotQty.filter(lot => lot !== null).join('<br>');

                offer[key].bidround_ending_at = this.$dateTime(offer[key].ending_at);

                offer[key].url = this.$$route('quote.show', {'bidRoundMember': offer[key].bid_round_member.id});

                let lotOffer = [];
                lotOffer.push(offer[key].bid_round_member.lot_offer_1, offer[key].bid_round_member.lot_offer_2, offer[key].bid_round_member.lot_offer_3, offer[key].bid_round_member.lot_offer_4);
                offer[key].lot_offer = lotOffer.map(lot => {
                    return lot ? this.$currency(lot) : null;
                }).filter(lot => lot !== null).join('<br>');

                offer[key].price_per_unit = lotOffer.map((lot, index) => {
                    return lot ? this.$currency(lot / lotQty[index]) : null;
                }).filter(lot => lot !== null).join('<br>');

                let lotDelivery = [];
                lotDelivery.push(offer[key].bid_round_member.lot_delivery_1, offer[key].bid_round_member.lot_delivery_2, offer[key].bid_round_member.lot_delivery_3, offer[key].bid_round_member.lot_delivery_4);
                offer[key].lot_delivery = lotDelivery.filter(lot => lot !== null).join('<br>');

                return offer[key];
            });
        },
        noOffers() {
            return this.editableOffers.length === 0;
        },
    },

};
</script>
